import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sim-detail-row',
  imports: [],
  template: '<ng-content />',
  styleUrl: './detail-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'detail-row',
    '[class.detail-row--dense]': 'dense()',
    '[class.detail-row--stack]': 'stackMobile()'
  }
})
export class SimDetailRowComponent {
  readonly dense = input(false, { transform: booleanAttribute });
  readonly stackMobile = input(false, { transform: booleanAttribute });
}
